module.exports = __webpack_public_path__ + "static/media/expert.b563a681.png";